module.exports = __webpack_public_path__ + "img/banner.a4eb81ee.jpg";